import React from 'react';

export default () => (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <circle cx="8" cy="8" r="7" stroke="#707070" strokeWidth="0.5" fill="#707070" />

        <circle cx="4.5" cy="8" r="1" fill="white" />
        <circle cx="8" cy="8" r="1" fill="white" />
        <circle cx="11.5" cy="8" r="1" fill="white" />
    </svg>
);
